export type DashboardLoginType = "admin" | "team";

const STORAGE_KEY = "dashboardLastLoginType";

export const getLastLoginType = (): DashboardLoginType => {
  if (typeof window === "undefined") return "team";

  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === "admin" || stored === "team") {
    return stored;
  }

  return "team";
};

export const setLastLoginType = (loginType: DashboardLoginType): void => {
  if (typeof window === "undefined") return;
  localStorage.setItem(STORAGE_KEY, loginType);
};
